import React, { useEffect, useState } from 'react';
import { FacebookIcon, MessageSquareIcon, PhoneIcon, CalendarIcon, ShoppingCartIcon, UserIcon, MessageCircleIcon, GlobeIcon, BotIcon, ArrowRightIcon } from 'lucide-react';
interface NotificationMessage {
  id: number;
  text: string;
  channel: 'facebook' | 'messenger' | 'website' | 'phone' | 'meeting' | 'sale' | 'offer' | 'gpt' | 'lead' | 'signup';
  userName: string;
  userImage: string;
  timestamp: string;
  isSpecial?: boolean;
}
const userImages = ['https://randomuser.me/api/portraits/women/12.jpg', 'https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/women/68.jpg', 'https://randomuser.me/api/portraits/men/45.jpg', 'https://randomuser.me/api/portraits/women/33.jpg', 'https://randomuser.me/api/portraits/men/91.jpg', 'https://randomuser.me/api/portraits/women/56.jpg', 'https://randomuser.me/api/portraits/men/22.jpg', 'https://randomuser.me/api/portraits/women/17.jpg', 'https://randomuser.me/api/portraits/men/83.jpg'];
const userNames = ['Emma', 'Noah', 'Olivia', 'Liam', 'Ava', 'William', 'Sophia', 'James', 'Isabella', 'Oliver', 'Charlotte', 'Benjamin', 'Mia', 'Elijah', 'Amelia', 'Lucas', 'Harper', 'Mason', 'Evelyn', 'Logan', 'Abigail', 'Alexander', 'Emily', 'Ethan', 'Elizabeth', 'Jacob', 'Sofia', 'Michael', 'Avery', 'Daniel', 'Ella', 'Henry', 'Scarlett', 'Jackson', 'Grace', 'Sebastian', 'Chloe', 'Aiden', 'Victoria', 'Matthew', 'Riley', 'Samuel', 'Aria', 'David', 'Lily', 'Joseph', 'Aubrey', 'Carter', 'Zoey', 'Owen', 'Hannah', 'Wyatt', 'Lillian', 'John', 'Addison', 'Jack', 'Eleanor', 'Luke', 'Natalie', 'Jayden', 'Luna', 'Dylan', 'Savannah', 'Grayson', 'Brooklyn', 'Levi', 'Audrey', 'Isaac', 'Leah', 'Gabriel', 'Zoe', 'Julian', 'Stella', 'Mateo', 'Hazel', 'Anthony', 'Ellie', 'Jaxon', 'Paisley', 'Lincoln', 'Skylar', 'Joshua', 'Violet', 'Christopher', 'Claire', 'Andrew', 'Bella', 'Theodore', 'Aurora', 'Caleb', 'Lucy', 'Ryan', 'Anna', 'Asher', 'Samantha', 'Nathan', 'Caroline', 'Thomas', 'Genesis', 'Leo', 'Aaliyah', 'Isaiah', 'Kennedy', 'Charles', 'Kinsley', 'Josiah', 'Allison', 'Hudson', 'Maya', 'Christian', 'Sarah', 'Hunter', 'Madelyn', 'Connor', 'Adeline', 'Eli', 'Alexa', 'Ezra', 'Ariana', 'Aaron', 'Elena', 'Landon', 'Gabriella', 'Adrian', 'Naomi', 'Jonathan', 'Alice', 'Nolan', 'Sadie', 'Jeremiah', 'Hailey', 'Easton', 'Eva', 'Elias', 'Emilia', 'Colton', 'Autumn', 'Cameron', 'Quinn', 'Carson', 'Nevaeh', 'Jace', 'Piper', 'Cooper', 'Ruby', 'Dominic', 'Serenity', 'Ian', 'Willow', 'Kai', 'Everly', 'Juan', 'Lydia', 'Miguel', 'Isla', 'Colin', 'Peyton', 'Max', 'Melanie'];
const randomTimes = ['2 min ago', '5 min ago', '9 min ago', '10 min ago', '3 min ago', '7 min ago', '1 min ago', '4 min ago', '8 min ago', '6 min ago'];
const generateNotifications = (): NotificationMessage[] => {
  const notifications: NotificationMessage[] = [
  // Facebook notifications
  {
    id: 1,
    text: 'ShoPilots just commented on a social media post',
    channel: 'facebook',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  }, {
    id: 2,
    text: 'We just answered {name} on Facebook',
    channel: 'facebook',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  }, {
    id: 3,
    text: 'ShoPilots posted a new special offer on Facebook',
    channel: 'facebook',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Messenger notifications
  {
    id: 4,
    text: 'We replied to {name} on Messenger',
    channel: 'messenger',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Phone notifications
  {
    id: 5,
    text: 'Just called a new client',
    channel: 'phone',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Meeting notifications
  {
    id: 6,
    text: 'Booked a meeting with {name}',
    channel: 'meeting',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Sale notifications
  {
    id: 7,
    text: 'Sold Samsung TV 65 inches to {name}',
    channel: 'sale',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  }, {
    id: 8,
    text: 'Sold iPhone 15 Pro to {name}',
    channel: 'sale',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  }, {
    id: 9,
    text: 'Sold Sony PlayStation 5 to {name}',
    channel: 'sale',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Website notifications
  {
    id: 10,
    text: "Answered {name}'s question on the website",
    channel: 'website',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // GPT Store notifications
  {
    id: 11,
    text: 'Collected new lead from GPT Store',
    channel: 'gpt',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  },
  // Lead notifications
  {
    id: 12,
    text: 'Called the new lead {name}',
    channel: 'lead',
    userName: userNames[Math.floor(Math.random() * userNames.length)],
    userImage: userImages[Math.floor(Math.random() * userImages.length)],
    timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)]
  }];
  // Replace {name} placeholder with random names
  return notifications.map(notification => {
    return {
      ...notification,
      text: notification.text.replace('{name}', notification.userName)
    };
  });
};
const ConversationNotifier: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationMessage[]>(generateNotifications());
  const [currentNotification, setCurrentNotification] = useState<NotificationMessage | null>(null);
  const [showNotification, setShowNotification] = useState(false);
  const [totalConversations, setTotalConversations] = useState(4826732);
  const [showSignupNotification, setShowSignupNotification] = useState(false);
  useEffect(() => {
    // Increment total conversations counter slowly
    const counterInterval = setInterval(() => {
      setTotalConversations(prev => prev + 1);
    }, 30000); // Every 30 seconds
    // Show a new notification every 7-15 seconds
    const showNextNotification = () => {
      // Every 4th notification (approximately), show the signup notification
      const shouldShowSignup = Math.random() < 0.25 && !showSignupNotification;
      if (shouldShowSignup) {
        // Create special signup notification
        const signupNotification: NotificationMessage = {
          id: Date.now(),
          text: `Shopilots handled ${totalConversations.toLocaleString()} conversations. The next conversation should be yours!`,
          channel: 'signup',
          userName: 'Shopilots',
          userImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rhREvAJ4b5296S85upFAnM/logonew.png',
          timestamp: 'Just now',
          isSpecial: true
        };
        setCurrentNotification(signupNotification);
        setShowSignupNotification(true);
      } else {
        // Regular notification
        const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
        const updatedNotification = {
          ...randomNotification,
          id: Date.now(),
          timestamp: randomTimes[Math.floor(Math.random() * randomTimes.length)],
          userName: userNames[Math.floor(Math.random() * userNames.length)],
          userImage: userImages[Math.floor(Math.random() * userImages.length)]
        };
        // Update the text to include the new random name
        updatedNotification.text = updatedNotification.text.replace('{name}', updatedNotification.userName);
        setCurrentNotification(updatedNotification);
        setShowSignupNotification(false);
      }
      setShowNotification(true);
      // Hide notification after 5 seconds for regular notifications, 8 seconds for signup
      setTimeout(() => {
        setShowNotification(false);
        setShowSignupNotification(false);
      }, shouldShowSignup ? 8000 : 5000);
    };
    // Initial notification after 5 seconds (delayed)
    const initialTimer = setTimeout(showNextNotification, 5000);
    // Set up recurring notifications with 7-15 second intervals
    const notificationInterval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 8000) + 7000; // 7-15 seconds
      setTimeout(showNextNotification, randomDelay);
    }, 15000); // Set the interval to 15 seconds to ensure notifications don't stack
    return () => {
      clearInterval(counterInterval);
      clearInterval(notificationInterval);
      clearTimeout(initialTimer);
    };
  }, [notifications, totalConversations, showSignupNotification]);
  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'facebook':
        return <FacebookIcon className="h-4 w-4 text-blue-600" data-id="element-1136" />;
      case 'messenger':
        return <MessageCircleIcon className="h-4 w-4 text-blue-500" data-id="element-1137" />;
      case 'website':
        return <GlobeIcon className="h-4 w-4 text-green-600" data-id="element-1138" />;
      case 'phone':
        return <PhoneIcon className="h-4 w-4 text-red-500" data-id="element-1139" />;
      case 'meeting':
        return <CalendarIcon className="h-4 w-4 text-purple-600" data-id="element-1140" />;
      case 'sale':
        return <ShoppingCartIcon className="h-4 w-4 text-orange-500" data-id="element-1141" />;
      case 'offer':
        return <MessageSquareIcon className="h-4 w-4 text-yellow-500" data-id="element-1142" />;
      case 'gpt':
        return <BotIcon className="h-4 w-4 text-indigo-600" data-id="element-1143" />;
      case 'lead':
        return <UserIcon className="h-4 w-4 text-teal-600" data-id="element-1144" />;
      case 'signup':
        return <MessageSquareIcon className="h-4 w-4 text-indigo-600" data-id="element-1145" />;
      default:
        return <MessageSquareIcon className="h-4 w-4 text-gray-600" data-id="element-1146" />;
    }
  };
  const handleNotificationClick = () => {
    // Open the wizard modal for any notification click
    window.dispatchEvent(new Event('open-wizard'));
  };
  return <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end" data-id="element-1147">
      {/* Hidden counter for tracking total conversations */}
      <div className="hidden" data-id="element-1148">{totalConversations.toLocaleString()}</div>
      {/* Notification popup */}
      <div className={`transform transition-all duration-500 ease-in-out ${showNotification ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`} data-id="element-1149">
        {currentNotification && (currentNotification.isSpecial ?
      // Special signup notification - larger and clickable
      <div onClick={handleNotificationClick} className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg shadow-lg p-4 mb-3 max-w-xs w-full border border-indigo-300 flex items-start cursor-pointer hover:shadow-xl transition-shadow duration-200" data-id="element-1150">
              <img src={currentNotification.userImage} alt="Shopilots" className="w-12 h-12 rounded-full mr-3 object-cover border-2 border-white" data-id="element-1151" />
              <div className="flex-1" data-id="element-1152">
                <p className="text-sm text-white font-medium mb-1" data-id="element-1153">
                  {currentNotification.text}
                </p>
                <button className="mt-2 bg-white text-indigo-700 rounded-full px-3 py-1 text-xs font-medium flex items-center" data-id="element-1154">
                  Sign Up Now <ArrowRightIcon className="h-3 w-3 ml-1" data-id="element-1155" />
                </button>
              </div>
            </div> :
      // Regular notification - now also clickable
      <div onClick={handleNotificationClick} className="bg-white rounded-lg shadow-lg p-4 mb-3 max-w-xs w-full border border-gray-200 flex items-start cursor-pointer hover:shadow-md transition-shadow duration-200" data-id="element-1156">
              <img src={currentNotification.userImage} alt={currentNotification.userName} className="w-10 h-10 rounded-full mr-3 object-cover" data-id="element-1157" />
              <div className="flex-1" data-id="element-1158">
                <div className="flex items-center mb-1" data-id="element-1159">
                  {getChannelIcon(currentNotification.channel)}
                  <span className="text-xs text-gray-500 ml-1" data-id="element-1160">
                    {currentNotification.timestamp}
                  </span>
                </div>
                <p className="text-sm text-gray-800" data-id="element-1161">
                  {currentNotification.text}
                </p>
              </div>
            </div>)}
      </div>
    </div>;
};
export default ConversationNotifier;